import axios from 'axios';

const api = axios.create({
  baseURL: 'https://appdogsville.com.br/index.php/api/'
});

export default api;
